module.exports = __webpack_public_path__ + "img/icon_page1_line3.ec0c2a10.png";